import React, { FC } from 'react';
import { Wrapper } from './styles';

interface Props {
  children: React.ReactNode;
}

/**
 * A React component that acts as a wrapper for its child components.
 */

const PageSwitcher: FC<Props> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default PageSwitcher;
